<div class="modal solid processDetails open" id="ProcessDetails">
  <div (click)="cancel()" class="close cancel" id="CancelXButton"></div>
  <div class="header">
    @if (data.showIcon) {
      <div class="network-issue-icon icon-Network-Failure"></div>
    }
    <div class="title">{{data.title ? data.title : 'Step Details'}}</div>
  </div>
  <div class="subtitle">{{this.originalStep.stepName}}</div>
  <div class="header-divider"></div>
  <app-table
    [value]="precheckData"
    [tableStyle]="{ 'max-width': '34.5rem' }"
    >
    <ng-template appTableTemplate="header">
      <tr>
        <th>Message</th>
        <th>Level</th>
      </tr>
    </ng-template>
    <ng-template appTableTemplate="body" let-rowData>
      <tr>
        <td>{{ rowData.message }}</td>
        <td>
          @if (rowData.level === 'INFO') {
            <img src="/assets/svgs/Growl_Success.svg" width="22" />
          }
          @if (rowData.level === 'WARN') {
            <img src="/assets/svgs/Growl_Warning.svg" width="22" />
          }
          @if (rowData.level === 'ERROR') {
            <img src="/assets/svgs/Growl_Error.svg" width="22" />
          }
        </td>
      </tr>
    </ng-template>
  </app-table>
</div>
